import CSS from "./Text.module.scss";

type TextProps = {
  children: React.ReactNode|React.ReactNode[],
}
export function Text({children}: TextProps) {
  return (
    <div className={CSS.container}>{children}</div>
  )
}